const LOCKED_STATES = new Set(['cerrado', 'rendido', 'liquidado']);
const OPEN_STATES = new Set(['en_curso', 'abierto']);

export const RETIRO_BLOQUEADO_MENSAJE =
  'El retiro/devolucion debe generarse desde el modulo formal de Retiros o Emision de Guia';

const norm = value => String(value || '').trim().toLowerCase();

export function isRepartoLocked(estado) {
  return LOCKED_STATES.has(norm(estado));
}

/**
 * Which buttons the reparto detail may enable for a given reparto state.
 * `can(code)` answers whether the current user holds a permission.
 */
export function getRepartoActions(estado, can = () => true, { rendiciones = [], liquidaciones = [] } = {}) {
  const state = norm(estado);
  const open = OPEN_STATES.has(state);
  const hasPending = (list) => list.some(item => norm(item?.estado) === 'pendiente');
  return {
    locked: LOCKED_STATES.has(state),
    iniciar: state === 'borrador' && can('REPARTOS_EDITAR'),
    entregar: open && can('REPARTOS_REGISTRAR_ENTREGA'),
    retener: open && can('REPARTOS_REGISTRAR_NOVEDAD'),
    cerrar: open && can('REPARTOS_CERRAR'),
    rendir: (state === 'cerrado' || state === 'rendicion_parcial') && can('REPARTOS_RENDIR'),
    aprobar: state === 'rendicion_parcial' && hasPending(rendiciones) && can('REPARTOS_RENDIR'),
    liquidar: state === 'rendido' && can('REPARTOS_LIQUIDAR'),
    pagar: hasPending(liquidaciones) && can('REPARTOS_LIQUIDAR'),
  };
}

export function canActOnGuia(guiaEstado) {
  return ['asignada', 'reprogramada'].includes(norm(guiaEstado));
}

/** Why a guide action button is disabled, shown as its tooltip; undefined when it is available. */
export function guiaActionBlockReason({ guiaEstado, repartoEstado, permission, can = () => true }) {
  if (!canActOnGuia(guiaEstado)) return `La guía ya está ${norm(guiaEstado) || 'procesada'}.`;
  if (!OPEN_STATES.has(norm(repartoEstado))) return `El reparto está ${norm(repartoEstado) || 'sin estado'}.`;
  if (!can(permission)) return `Falta el permiso ${permission}.`;
  return undefined;
}

/** Guides can be added until the reparto is closed, matching the API (assertRepartoOperable). */
export function canAddGuias(estado, can = () => true) {
  return !isRepartoLocked(estado) && can('REPARTOS_ASIGNAR_GUIAS');
}

/** Driver list filter for a reparto: the active drivers of its branch. */
export function choferesFilter(sucursalId) {
  return sucursalId ? { sucursalId: String(sucursalId), estados: ['ACTIVO'] } : null;
}
